import { useState } from "react";
import { createHeaders } from "@project-mgmt/api-client";
export function useMarkAsRead(workspaceId) {
    const [isLoading, setIsLoading] = useState(false);
    const markAsRead = async (notificationId) => {
        setIsLoading(true);
        try {
            const response = await fetch(`/api/notifications/${notificationId}/read`, {
                method: "PUT",
                headers: createHeaders(workspaceId),
            });
            if (!response.ok) {
                throw new Error("Failed to mark notification as read");
            }
            return response.json();
        }
        catch (error) {
            console.error("Error marking notification as read:", error);
            throw error;
        }
        finally {
            setIsLoading(false);
        }
    };
    const markAllAsRead = async () => {
        setIsLoading(true);
        try {
            const response = await fetch("/api/notifications/mark-all-read", {
                method: "PUT",
                headers: createHeaders(workspaceId),
            });
            if (!response.ok) {
                throw new Error("Failed to mark all notifications as read");
            }
            return response.json();
        }
        catch (error) {
            console.error("Error marking all notifications as read:", error);
            throw error;
        }
        finally {
            setIsLoading(false);
        }
    };
    return {
        markAsRead,
        markAllAsRead,
        isLoading,
    };
}
